export enum EmailSubscriptionTypes {
  DefaultEmailSubscription = 1,
}
